import { render, staticRenderFns } from "./MuralKpiRow.vue?vue&type=template&id=10604c08&scoped=true"
import script from "./MuralKpiRow.vue?vue&type=script&lang=js"
export * from "./MuralKpiRow.vue?vue&type=script&lang=js"
import style0 from "./MuralKpiRow.vue?vue&type=style&index=0&id=10604c08&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10604c08",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10604c08')) {
      api.createRecord('10604c08', component.options)
    } else {
      api.reload('10604c08', component.options)
    }
    module.hot.accept("./MuralKpiRow.vue?vue&type=template&id=10604c08&scoped=true", function () {
      api.rerender('10604c08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/mural/MuralKpiRow.vue"
export default component.exports